import { render } from "./VerifiedFilesReportsList.vue?vue&type=template&id=142ad1b3&scoped=true"
import script from "./VerifiedFilesReportsList.vue?vue&type=script&lang=js"
export * from "./VerifiedFilesReportsList.vue?vue&type=script&lang=js"

import "./VerifiedFilesReportsList.vue?vue&type=style&index=0&id=142ad1b3&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142ad1b3"]])

export default __exports__